// extracted by mini-css-extract-plugin
module.exports = {"SendMessage":"SendMessage_SendMessage__dwsmb","emoji":"SendMessage_emoji__2M-Bf"};